import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=fb29bd2a&"
import script from "./Meetings.vue?vue&type=script&lang=js&"
export * from "./Meetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb29bd2a')) {
      api.createRecord('fb29bd2a', component.options)
    } else {
      api.reload('fb29bd2a', component.options)
    }
    module.hot.accept("./Meetings.vue?vue&type=template&id=fb29bd2a&", function () {
      api.rerender('fb29bd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Meetings.vue"
export default component.exports